import React, { useEffect, useRef } from 'react';

/**
 * Thin wrapper over <wa-drawer> for the manage layer.
 *
 * Follows PortalLayout's established pattern rather than inventing a second
 * one: React state drives the `open` PROPERTY through an effect (never a JSX
 * boolean attribute — see src/components/wa/useWaBooleanProps.js for why a
 * `false` would serialize to `open="false"` and read as true), and every
 * dismissal path the component owns (esc, backdrop, its own close button)
 * reports back through `wa-after-hide` so state cannot drift from the DOM.
 */
function SchedulingDrawer({ open, label, onClose, children }) {
	const drawerRef = useRef(null);

	useEffect(() => {
		const drawer = drawerRef.current;
		if (drawer) drawer.open = Boolean(open);
	}, [open]);

	useEffect(() => {
		const drawer = drawerRef.current;
		if (!drawer) return undefined;
		const handleHide = () => onClose?.();
		drawer.addEventListener('wa-after-hide', handleHide);
		return () => drawer.removeEventListener('wa-after-hide', handleHide);
	}, [onClose]);

	return (
		<wa-drawer ref={drawerRef} label={label} placement='end' className='ts-drawer'>
			{children}
		</wa-drawer>
	);
}

export default SchedulingDrawer;
